import {makeAutoObservable} from "mobx";
import {fetchAddItem} from "@/services/cart";
import {triggerEvent, registerEvent} from "@/utils/custom-events";

class Product {
  variantId = 0;
  quantity = 1;
  sellingPlanId = null;
  loading = false;

  constructor() {
    makeAutoObservable(this);

    registerEvent("quantity:reset", () => {
      this.setQuantity(1);
    });
  }

  setSellingPlan(sellingPlanId) {
    this.sellingPlanId = sellingPlanId;
  }

  setVariantId(variantId) {
    const oldVariantId = this.variantId;

    if (oldVariantId !== variantId) {
      this.variantId = variantId;
      this.quantity = 1;
      this.sellingPlanId = null;

      triggerEvent("variant:change", {
        variantId: this.variantId,
      });
    }
  }

  setQuantity(quantity) {
    if (quantity <= 0) return;
    this.quantity = quantity;
  }

  async addToCart() {
    if (this.loading) return;

    try {
      const result = await fetchAddItem({
        id: this.variantId,
        quantity: this.quantity,
        ...(this.sellingPlanId && {
          selling_plan: this.sellingPlanId,
        }),
      });
      this.loading = false;
      return result;
    } catch (e) {
      console.error(e.message);
      this.loading = false;
    } finally {
      triggerEvent("cart:modal:toggle", {
        open: true,
      });
    }
  }
}

export const product = new Product();
